<template>
  <el-dialog
      :visible.sync="visible"
      :modal-append-to-body="false"
      :showClose="false"
      :close-on-click-modal="false"
      width="40%"
  >
    <div class="visible2">
      <i class="el-icon-warning"/>
      <p>
        {{ resText }}
      </p>
    </div>
    <div class="botBtn">
      <el-button key="back" @click="close()">
        キャンセル
      </el-button>
      <el-button key="submit" type="primary" :loading="loading" @click="confirm()">
        OK
      </el-button>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name: "modalWring",
  data() {
    return {
      visible: false,
      loading: false,
      resText: "",
      resType: "",
      resData: {},

    }
  },
  methods: {
    close() {
      this.visible = false
      this.$emit("close", this.resData, this.resType)
    },
    confirm() {
      this.visible = false
      this.$emit("confirm", this.resData, this.resType)
    },
    showEdit({text, data, type}) {
      this.visible = true
      this.resText = text
      this.resData = data
      this.resType = type
    }
  }
}
</script>


<style scoped lang="less">
.botBtn {
  display: flex;
  justify-content: center;
  margin: 20px 0 0;

  .el-button {
    width: 119px;
    height: 38px;
    text-align: center;
    padding: 0;
  }

  .btn2 {
    background: #FF3333;
    color: #fff;
  }
}

/deep/ .visible2 {
  text-align: center;

  i {
    font-size: 43px;
    color: #f60;
    display: block;
  }

  p {
    line-height: 45px;
    font-size: 15px;
  }
}
</style>